<template>
  <FormUpload :doc_number="doc_number" type="INVOICE" id="file-upload-invoice" />
</template>

<script>
import FormUpload from '@/components/Form/Upload'
export default {
  components: {
    FormUpload,
  },
  props: {
    doc_number: [String, Number],
  },
}
</script>
